export const establishmentFieldRequestsHeaderElements = [
  { label: "Fecha", value: "displayFecha", align: "inherit" },
  { label: "Titular Cuenta", value: "titularCuenta", align: "inherit" },
  { label: "Tipo", value: "tipoOperacion", align: "inherit" },
  { label: "Establecimiento/Lote", value: "displayEstablecimientoLote", align: "inherit" },
  { label: "Estado", value: "displayEstado", align: "center" },
];
